<template>
  <div v-show="show" class="loader-wrapper w-full h-full">
        <div class="flex h-full items-center justify-center flex-col">
            <div class="text-gray-400 text-sm pb-4">{{ loadingText }}</div>
            <feather type="loader" :stroke="theme.colors.steelBlue" animation="spin"></feather>
        </div>
  </div>
</template>

<script>
import resolveConfig from 'tailwindcss/resolveConfig'
import tailwindConfig from '../../tailwind.config.js'

export default {
      name: 'loader',
      props: {
            show: {
                  type: Boolean,
                  default: true,
                  require: true,
            }
      },
      data(){
            const {theme} = resolveConfig(tailwindConfig)
            return {
                  library: [
                        this.$t('plase_wait'),
                        this.$t('gathering'),
                        this.$t('combining'),
                        this.$t('structuring'),
                        this.$t('organising'),
                        this.$t('collecting'),
                        this.$t('displaying')
                  ],
                  intervalIndex: 0,
                  interval: null,
                  theme: theme,
            }
      },
      computed: {
            loadingText () {
                  return this.library[this.intervalIndex];
            }
      },
      methods: {
            rotateText(time) {
                  this.interval = setInterval(() => {
                        if(this.intervalIndex == this.library.length - 1) {
                              this.intervalIndex = 0
                        } else {
                              this.intervalIndex += 1
                        }
                  },time)
            },
            resetInterval(){
                  clearInterval(this.interval)
            }
      }, 
      mounted(){
            this.rotateText(3000)
      },
      beforeDestroy(){
            this.resetInterval;
      }
}
</script>

<style lang="sass">
.loader-wrapper > div
      min-height: 150px
</style>